<template>
  <div class="pt-3 px-3 pb-1">
           
      <p v-if="contacts.length == 0" class="text-center">No links</p>

        <div v-else>

       <!--- Desktop --->
        <table class="table d-none d-md-table">
              <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="80%">{{total}}</th>
                  <th class="first-right px-3" width="20%">Added</th>
                </tr>
              </thead>
              <tbody>
    <tr v-for="(contact, index) in contacts" :key="index">
        <td class="pl-3"><small><a :href="contact.url" target="_blank">{{contact.url}}</a></small></td>
        <td class="pl-3 text-nowrap"><timeago
                  :datetime="contact.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(contact.created_at)"></timeago></td>
    </tr>
              </tbody>
            </table>

        <!--- Mobile --->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Url • Created</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(contact, index) in contacts" :key="index">
  
        <td class="pl-2 text-center">
            <div><b><a :href="contact.url" target="_blank">{{contact.url}}</a></b></div>
            <div><timeago
                  :datetime="contact.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(contact.created_at)"></timeago></div>
        </td>
      
            </tr>
          </tbody>
        </table>

        </div>
    </div>

</template>

<script>
export default {
  props: ['search_term'],

  watch: {
    search_term: function (val) {
      this.getContacts();
    }
  },

  data() {
    return {
      contacts: [],
      contactInfo: {},
      loading: false,
      total: 0,
    };
  },

  created() {
    this.getContacts();

    Echo.private("contacts")
      .listen("UpdateLinks", (event) => {
        this.getContacts();
      });

  },

  methods: {

    getContacts() {

      this.loading = true;

      axios
        .post('/links/get', {
          search_term: this.search_term
        })
        .then((response) => {
          this.contacts = response.data.contacts;
          this.total = response.data.total;
          this.loading = false;
        });
    },

  },
};
</script> 